import script from "./QuizzHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzHeader.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzHeader.vue?vue&type=style&index=0&id=6c3f5447&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c3f5447"]])

export default __exports__